if (!customElements.get('multicolumn-lead-copy')) {
  customElements.define(
    'multicolumn-lead-copy',
    class MulticolumnLeadCopy extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onCopyClick.bind(this));
      }

      onCopyClick(event) {
        const button = event.target.closest('[data-copy-text]');
        if (!button) return;

        event.preventDefault();
        const textToCopy = button.dataset.copyText;
        if (!textToCopy) return;

        navigator.clipboard.writeText(textToCopy).then(() => {
          const feedback = button.closest('.multicolumn-card__lead')?.querySelector('.multicolumn-card__lead-copy-feedback');
          if (!feedback) return;

          feedback.textContent = 'Email copied';
          feedback.classList.remove('visually-hidden');

          window.clearTimeout(this.copyTimeout);
          this.copyTimeout = window.setTimeout(() => {
            feedback.textContent = '';
            feedback.classList.add('visually-hidden');
          }, 2000);
        });
      }
    }
  );
}
